<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
          <div class="form js-form">
              <submenu></submenu>

              <div class="form__image-container">
                  <img class="form__image" :src="File.getPath(currentTenant.image)" />
              </div>

              <TextBox label="Settings_Group_Name"
                    v-model="tenant.name"
                    :validate="$v.tenant"
                    v-on:input="$v.tenant.name.$touch"
                    modelPath="name"
                    acc="name" />

              <TextBox label="Settings_Group_Description"
                    v-model="tenant.description"
                    :validate="$v.tenant"
                    v-on:input="$v.tenant.description.$touch"
                    modelPath="description"
                    acc="description" />

              <fieldset class="form__field">
                  <label for="fileUpload" class="form__label">{{ L.localize('Settings_Breadcrumb_Details_Image') }}</label>
                  <input type="file" class="form__input" ref="fileUpload" accept="image/*" />
              </fieldset>

              <TextBox label="Settings_Group_BeeClientId"
                       v-model="tenant.beeClientId"                       
                       modelPath="beeClientId"
                       acc="beeClientId" />

              <TextBox label="Settings_Group_BeeClientSecret"
                       v-model="tenant.beeClientSecret"
                       modelPath="beeClientSecret"
                       acc="beeClientSecret" />

              <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          </div>
      </div>
    </article>
  </article>
</template>

<script>
import L from 'services/Localization'
import Submenu from 'components/views/account/Submenu'
import { Validation } from 'components/helpers'
import { required } from 'vuelidate/lib/validators'
import notifications from 'mixins/notifications'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import File from 'services/File'
import TextBox from 'components/layout/forms/TextBox'
import Btn from 'components/layout/forms/Btn'

export default {
  name: 'account-home',
  components: { Submenu, Validation, TextBox, Btn },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      L: L,
      File: File,
      title: L.localize('Account_Breadcrumb'),
      tenant: {
        name: '',
        description: '',
        image: {},
        beeClientId: '',
        beeClientSecret: ''
      }
    }
  },
  created() {
    this.$store.dispatch('getTenantSession').then(() => {
      _.assign(this.tenant, this.currentTenant)
    })
  },
  computed: {
    ...mapGetters({
      currentTenant: 'getCurrentTenant'
    })
  },
  validations: {
    tenant: {
      name: { required },
      description: { required }
    }
  },
  methods: {
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      var data = new FormData();
      data.append('fileUpload', this.$refs.fileUpload.files[0]);
      data.append('name', this.tenant.name)
      data.append('description', this.tenant.description)
      data.append('beeClientId', this.tenant.beeClientId)
      data.append('beeClientSecret', this.tenant.beeClientSecret)
      data.append('webhookUrl', this.tenant.webhookUrl)
      this.$store.dispatch('updateTenant', data).then(
        // resolve
        () => {
          this.loading = false
          this.showNotification({
            title: L.localize('Label_SuccessCreation'),
            message: L.localize('Label_Success')
          })
          this.$store.dispatch('getTenantSession')
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Account.vue?6da8ad59